export default {
  id: 'placing-an-order',
  title: 'Placing an Order',
  content: `## Placing an Order

All paper trades in TradeLab are placed through the Trade page. Here is the full flow from start to confirmation.

---

## Step 1 — Open the Trade Page

Tap the **Trade** button (centre of the bottom navigation bar).

---

## Step 2 — Search for a Stock

Use the search bar at the top to find any NSE-listed stock. You can search by:
- Symbol (e.g., RELIANCE, INFY, TCS)
- Company name (e.g., "Infosys", "Tata Consultancy")

The app searches across all active NSE stocks. Tap the result to open that stock's trading screen.

---

## Step 3 — Read the Chart

Before placing an order, review the price chart shown on the trading screen:
- Check the current price and recent candle movement
- Use the chart to identify a sensible entry, stop loss, and target level
- Timeframes available: 1min, 5min, 15min, 1D

---

## Step 4 — Fill in Order Details

| Field | Description |
|---|---|
| Order Type | Market or Limit — see Order Types for details |
| Quantity | Number of shares to buy or sell |
| Price | For Limit orders — the price at which you want to fill |
| Stop Loss | Optional at order time — the price at which you will exit if wrong |
| Target | Optional at order time — the price at which you will take profit |
| Trade Type | INTRADAY (auto-exit at 3:10 PM) or DELIVERY (holds overnight) |

> Always set a Stop Loss before confirming. Entering without a stop is the single most common discipline failure TradeLab tracks.

---

## Step 5 — Confirm the Order

Review the order summary — symbol, quantity, order type, estimated trade value — then tap **Place Order**.

- **Market orders** fill immediately at the last fetched price
- **Limit orders** enter the queue as OPEN and fill when the stock price reaches your limit price

---

## Step 6 — Track in Orders

Your order appears immediately under **Orders → Open Orders**. Once filled, it moves to **Open Positions**.

---

## Order Source Tagging

Every order in TradeLab is tagged with its source:

| Source | What it means |
|---|---|
| MANUAL | Placed by you through the Trade page |
| ALGO_FLOW | Placed automatically by an active Algo Flow strategy |
| NYX_AI | Placed via a Nyx AI Trader Mode suggestion |

This lets you compare the performance of your manual decisions against automated strategies.`,
};
